import { Dispatch, SetStateAction, FC } from 'react'
import { Box, Button, Heading, Image, Stack } from '@chakra-ui/react'

import { ArrowLeft, CloudUpload } from 'components/icons'

type Props = {
  photo: string
  setPhoto: Dispatch<SetStateAction<string | null>>
  onClose: () => void
}

const SavePhotoFromWebcam: FC<Props> = ({ photo, setPhoto, onClose }) => {
  const savePhoto = () => {
    onClose()
  }

  return (
    <Stack align="center">
      <Heading fontWeight="bold" color="primary">
        Foto tirada com successo!
      </Heading>
      {photo && (
        <Box borderWidth="2px" rounded="md" borderColor="primary">
          <Image rounded="md" width="640px" height="360px" src={photo} alt="Foto tirada" />
        </Box>
      )}

      <Button size="md" minWidth="100%" variant="outline" leftIcon={<ArrowLeft />} onClick={() => setPhoto(null)}>
        Tirar outra foto
      </Button>

      <Button size="md" minWidth="100%" leftIcon={<CloudUpload />} onClick={savePhoto}>
        Salvar foto
      </Button>
    </Stack>
  )
}

export default SavePhotoFromWebcam
